/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import * as msRest from "@azure/ms-rest-js";


export const Gacha: msRest.CompositeMapper = {
  serializedName: "Gacha",
  type: {
    name: "Composite",
    className: "Gacha",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      upperTimes: {
        serializedName: "upperTimes",
        type: {
          name: "Number"
        }
      },
      winningRate: {
        serializedName: "winningRate",
        type: {
          name: "Number"
        }
      },
      gachaTimes: {
        serializedName: "gachaTimes",
        type: {
          name: "Number"
        }
      },
      iosDownloadUrl: {
        serializedName: "iosDownloadUrl",
        type: {
          name: "String"
        }
      },
      androidDownloadUrl: {
        serializedName: "androidDownloadUrl",
        type: {
          name: "String"
        }
      },
      canRetry: {
        serializedName: "canRetry",
        type: {
          name: "Boolean"
        }
      },
      retryInterval: {
        serializedName: "retryInterval",
        type: {
          name: "Number"
        }
      },
      createdAt: {
        serializedName: "createdAt",
        type: {
          name: "DateTime"
        }
      },
      startTime: {
        serializedName: "startTime",
        type: {
          name: "DateTime"
        }
      },
      endTime: {
        serializedName: "endTime",
        type: {
          name: "DateTime"
        }
      },
      gameTitle: {
        serializedName: "gameTitle",
        type: {
          name: "String"
        }
      },
      developerName: {
        serializedName: "developerName",
        type: {
          name: "String"
        }
      },
      iconImageUrl: {
        serializedName: "iconImageUrl",
        type: {
          name: "String"
        }
      },
      giftDetail: {
        serializedName: "giftDetail",
        type: {
          name: "String"
        }
      },
      gameIntroduction: {
        serializedName: "gameIntroduction",
        type: {
          name: "String"
        }
      },
      articleUrl: {
        serializedName: "articleUrl",
        type: {
          name: "String"
        }
      },
      gameReleaseTime: {
        serializedName: "gameReleaseTime",
        type: {
          name: "String"
        }
      },
      officialSiteUrl: {
        serializedName: "officialSiteUrl",
        type: {
          name: "String"
        }
      },
      gachaCount: {
        serializedName: "gachaCount",
        type: {
          name: "Number"
        }
      },
      iosDownloadCount: {
        serializedName: "iosDownloadCount",
        type: {
          name: "Number"
        }
      },
      androidDownloadCount: {
        serializedName: "androidDownloadCount",
        type: {
          name: "Number"
        }
      },
      encryptName: {
        serializedName: "encryptName",
        type: {
          name: "String"
        }
      },
      iv: {
        serializedName: "iv",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const GiftCode: msRest.CompositeMapper = {
  serializedName: "GiftCode",
  type: {
    name: "Composite",
    className: "GiftCode",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      code: {
        serializedName: "code",
        type: {
          name: "String"
        }
      },
      price: {
        serializedName: "price",
        type: {
          name: "Number"
        }
      },
      hash: {
        serializedName: "hash",
        type: {
          name: "String"
        }
      },
      iv: {
        serializedName: "iv",
        type: {
          name: "String"
        }
      },
      createdAt: {
        serializedName: "createdAt",
        type: {
          name: "DateTime"
        }
      },
      gacha: {
        serializedName: "gacha",
        type: {
          name: "Composite",
          className: "Gacha"
        }
      },
      isUsed: {
        serializedName: "isUsed",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const User: msRest.CompositeMapper = {
  serializedName: "User",
  type: {
    name: "Composite",
    className: "User",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      nickname: {
        serializedName: "nickname",
        type: {
          name: "String"
        }
      },
      mailAddress: {
        serializedName: "mailAddress",
        type: {
          name: "String"
        }
      },
      emailVerified: {
        serializedName: "emailVerified",
        type: {
          name: "Boolean"
        }
      },
      isOptout: {
        serializedName: "isOptout",
        type: {
          name: "Boolean"
        }
      },
      lastLoggedInAt: {
        serializedName: "lastLoggedInAt",
        type: {
          name: "DateTime"
        }
      },
      isOptin: {
        serializedName: "isOptin",
        type: {
          name: "Boolean"
        }
      },
      optinAt: {
        serializedName: "optinAt",
        type: {
          name: "DateTime"
        }
      },
      optoutAt: {
        serializedName: "optoutAt",
        type: {
          name: "DateTime"
        }
      },
      smsAuthedAt: {
        serializedName: "smsAuthedAt",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const GachaRegister: msRest.CompositeMapper = {
  serializedName: "GachaRegister",
  type: {
    name: "Composite",
    className: "GachaRegister",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      userId: {
        serializedName: "userId",
        type: {
          name: "String"
        }
      },
      gachaId: {
        serializedName: "gachaId",
        type: {
          name: "String"
        }
      },
      os: {
        serializedName: "os",
        type: {
          name: "String"
        }
      },
      createdAt: {
        serializedName: "createdAt",
        type: {
          name: "DateTime"
        }
      },
      user: {
        serializedName: "user",
        type: {
          name: "Composite",
          className: "User"
        }
      },
      gacha: {
        serializedName: "gacha",
        type: {
          name: "Composite",
          className: "Gacha"
        }
      },
      gachaRegister: {
        serializedName: "gachaRegister",
        type: {
          name: "Composite",
          className: "GachaRegister"
        }
      }
    }
  }
};

export const GachaResultHistory: msRest.CompositeMapper = {
  serializedName: "GachaResultHistory",
  type: {
    name: "Composite",
    className: "GachaResultHistory",
    modelProperties: {
      id: {
        required: true,
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      userId: {
        required: true,
        serializedName: "userId",
        type: {
          name: "String"
        }
      },
      gachaId: {
        required: true,
        serializedName: "gachaId",
        type: {
          name: "String"
        }
      },
      winningId: {
        serializedName: "winningId",
        type: {
          name: "String"
        }
      },
      createdAt: {
        required: true,
        serializedName: "createdAt",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const Session: msRest.CompositeMapper = {
  serializedName: "Session",
  type: {
    name: "Composite",
    className: "Session",
    modelProperties: {
      sessionId: {
        serializedName: "sessionId",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const LoginRequest: msRest.CompositeMapper = {
  serializedName: "LoginRequest",
  type: {
    name: "Composite",
    className: "LoginRequest",
    modelProperties: {
      idToken: {
        serializedName: "idToken",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const CreateGachaRequest: msRest.CompositeMapper = {
  serializedName: "CreateGachaRequest",
  type: {
    name: "Composite",
    className: "CreateGachaRequest",
    modelProperties: {
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      upperTimes: {
        serializedName: "upperTimes",
        type: {
          name: "Number"
        }
      },
      winningRate: {
        serializedName: "winningRate",
        type: {
          name: "Number"
        }
      },
      iosDownloadUrl: {
        serializedName: "iosDownloadUrl",
        type: {
          name: "String"
        }
      },
      androidDownloadUrl: {
        serializedName: "androidDownloadUrl",
        type: {
          name: "String"
        }
      },
      canRetry: {
        serializedName: "canRetry",
        type: {
          name: "Boolean"
        }
      },
      retryInterval: {
        serializedName: "retryInterval",
        type: {
          name: "Number"
        }
      },
      startTime: {
        serializedName: "startTime",
        type: {
          name: "DateTime"
        }
      },
      endTime: {
        serializedName: "endTime",
        type: {
          name: "DateTime"
        }
      },
      gameTitle: {
        serializedName: "gameTitle",
        type: {
          name: "String"
        }
      },
      developerName: {
        serializedName: "developerName",
        type: {
          name: "String"
        }
      },
      iconImageUrl: {
        serializedName: "iconImageUrl",
        type: {
          name: "String"
        }
      },
      giftDetail: {
        serializedName: "giftDetail",
        type: {
          name: "String"
        }
      },
      gameIntroduction: {
        serializedName: "gameIntroduction",
        type: {
          name: "String"
        }
      },
      articleUrl: {
        serializedName: "articleUrl",
        type: {
          name: "String"
        }
      },
      gameReleaseTime: {
        serializedName: "gameReleaseTime",
        type: {
          name: "String"
        }
      },
      officialSiteUrl: {
        serializedName: "officialSiteUrl",
        type: {
          name: "String"
        }
      },
      encryptName: {
        serializedName: "encryptName",
        type: {
          name: "String"
        }
      },
      iv: {
        serializedName: "iv",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const CreateGiftCodeBulkRequest: msRest.CompositeMapper = {
  serializedName: "CreateGiftCodeBulkRequest",
  type: {
    name: "Composite",
    className: "CreateGiftCodeBulkRequest",
    modelProperties: {
      giftCodes: {
        serializedName: "giftCodes",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "GiftCode"
            }
          }
        }
      }
    }
  }
};

export const UpdateGachaRequest: msRest.CompositeMapper = {
  serializedName: "UpdateGachaRequest",
  type: {
    name: "Composite",
    className: "UpdateGachaRequest",
    modelProperties: {
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      upperTimes: {
        serializedName: "upperTimes",
        type: {
          name: "Number"
        }
      },
      winningRate: {
        serializedName: "winningRate",
        type: {
          name: "Number"
        }
      },
      iosDownloadUrl: {
        serializedName: "iosDownloadUrl",
        type: {
          name: "String"
        }
      },
      androidDownloadUrl: {
        serializedName: "androidDownloadUrl",
        type: {
          name: "String"
        }
      },
      canRetry: {
        serializedName: "canRetry",
        type: {
          name: "Boolean"
        }
      },
      retryInterval: {
        serializedName: "retryInterval",
        type: {
          name: "Number"
        }
      },
      startTime: {
        serializedName: "startTime",
        type: {
          name: "DateTime"
        }
      },
      endTime: {
        serializedName: "endTime",
        type: {
          name: "DateTime"
        }
      },
      gameTitle: {
        serializedName: "gameTitle",
        type: {
          name: "String"
        }
      },
      developerName: {
        serializedName: "developerName",
        type: {
          name: "String"
        }
      },
      iconImageUrl: {
        serializedName: "iconImageUrl",
        type: {
          name: "String"
        }
      },
      giftDetail: {
        serializedName: "giftDetail",
        type: {
          name: "String"
        }
      },
      gameIntroduction: {
        serializedName: "gameIntroduction",
        type: {
          name: "String"
        }
      },
      articleUrl: {
        serializedName: "articleUrl",
        type: {
          name: "String"
        }
      },
      gameReleaseTime: {
        serializedName: "gameReleaseTime",
        type: {
          name: "String"
        }
      },
      officialSiteUrl: {
        serializedName: "officialSiteUrl",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const PlayGachaResponse: msRest.CompositeMapper = {
  serializedName: "PlayGachaResponse",
  type: {
    name: "Composite",
    className: "PlayGachaResponse",
    modelProperties: {
      isWinning: {
        required: true,
        serializedName: "isWinning",
        type: {
          name: "Boolean"
        }
      },
      winningId: {
        required: true,
        serializedName: "winningId",
        type: {
          name: "String"
        }
      },
      price: {
        required: true,
        serializedName: "price",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const PlayGachaRequest: msRest.CompositeMapper = {
  serializedName: "PlayGachaRequest",
  type: {
    name: "Composite",
    className: "PlayGachaRequest",
    modelProperties: {
      os: {
        serializedName: "os",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const GenerateSmsAuthIdRequest: msRest.CompositeMapper = {
  serializedName: "GenerateSmsAuthIdRequest",
  type: {
    name: "Composite",
    className: "GenerateSmsAuthIdRequest",
    modelProperties: {
      phoneNumber: {
        serializedName: "phoneNumber",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const GenerateSmsAuthIdResponse: msRest.CompositeMapper = {
  serializedName: "GenerateSmsAuthIdResponse",
  type: {
    name: "Composite",
    className: "GenerateSmsAuthIdResponse",
    modelProperties: {
      authId: {
        serializedName: "authId",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const VerifySmsAuthCodeRequest: msRest.CompositeMapper = {
  serializedName: "VerifySmsAuthCodeRequest",
  type: {
    name: "Composite",
    className: "VerifySmsAuthCodeRequest",
    modelProperties: {
      code: {
        serializedName: "code",
        type: {
          name: "String"
        }
      },
      authId: {
        serializedName: "authId",
        type: {
          name: "String"
        }
      },
      phoneNumber: {
        serializedName: "phoneNumber",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const UpdateUserOptoutRequest: msRest.CompositeMapper = {
  serializedName: "UpdateUserOptoutRequest",
  type: {
    name: "Composite",
    className: "UpdateUserOptoutRequest",
    modelProperties: {
      isOptout: {
        serializedName: "isOptout",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const GachaWinning: msRest.CompositeMapper = {
  serializedName: "GachaWinning",
  type: {
    name: "Composite",
    className: "GachaWinning",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      status: {
        serializedName: "status",
        type: {
          name: "String"
        }
      },
      createdAt: {
        serializedName: "createdAt",
        type: {
          name: "DateTime"
        }
      },
      gacha: {
        serializedName: "gacha",
        type: {
          name: "Composite",
          className: "Gacha"
        }
      },
      user: {
        serializedName: "user",
        type: {
          name: "Composite",
          className: "User"
        }
      },
      giftCode: {
        serializedName: "giftCode",
        type: {
          name: "Composite",
          className: "GiftCode"
        }
      },
      os: {
        serializedName: "os",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const UpdateGachaWinningStatusRequest: msRest.CompositeMapper = {
  serializedName: "UpdateGachaWinningStatusRequest",
  type: {
    name: "Composite",
    className: "UpdateGachaWinningStatusRequest",
    modelProperties: {
      status: {
        serializedName: "status",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const UpdateUserOptinRequest: msRest.CompositeMapper = {
  serializedName: "UpdateUserOptinRequest",
  type: {
    name: "Composite",
    className: "UpdateUserOptinRequest",
    modelProperties: {
      isOptin: {
        serializedName: "isOptin",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const ListGachaRegisterResponse: msRest.CompositeMapper = {
  serializedName: "ListGachaRegisterResponse",
  type: {
    name: "Composite",
    className: "ListGachaRegisterResponse",
    modelProperties: {
      registers: {
        serializedName: "registers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "GachaRegister"
            }
          }
        }
      },
      totalNum: {
        serializedName: "totalNum",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const ApproveGachaWinningRequest: msRest.CompositeMapper = {
  serializedName: "ApproveGachaWinningRequest",
  type: {
    name: "Composite",
    className: "ApproveGachaWinningRequest",
    modelProperties: {
      winnings: {
        serializedName: "winnings",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "GachaWinning"
            }
          }
        }
      }
    }
  }
};

export const EmailTemplate: msRest.CompositeMapper = {
  serializedName: "EmailTemplate",
  type: {
    name: "Composite",
    className: "EmailTemplate",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        type: {
          name: "String"
        }
      },
      body: {
        serializedName: "body",
        type: {
          name: "String"
        }
      },
      htmlBody: {
        required: true,
        serializedName: "htmlBody",
        type: {
          name: "String"
        }
      },
      createdAt: {
        serializedName: "createdAt",
        type: {
          name: "DateTime"
        }
      },
      updatedAt: {
        serializedName: "updatedAt",
        type: {
          name: "DateTime"
        }
      },
      gachaId: {
        serializedName: "gachaId",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const EditEmailTemplateRequest: msRest.CompositeMapper = {
  serializedName: "EditEmailTemplateRequest",
  type: {
    name: "Composite",
    className: "EditEmailTemplateRequest",
    modelProperties: {
      title: {
        serializedName: "title",
        type: {
          name: "String"
        }
      },
      body: {
        serializedName: "body",
        type: {
          name: "String"
        }
      },
      htmlBody: {
        required: true,
        serializedName: "htmlBody",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const ListGachaWinningResponse: msRest.CompositeMapper = {
  serializedName: "ListGachaWinningResponse",
  type: {
    name: "Composite",
    className: "ListGachaWinningResponse",
    modelProperties: {
      winnings: {
        serializedName: "winnings",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "GachaWinning"
            }
          }
        }
      },
      totalNum: {
        serializedName: "totalNum",
        type: {
          name: "Number"
        }
      }
    }
  }
};

export const PublicGacha: msRest.CompositeMapper = {
  serializedName: "PublicGacha",
  type: {
    name: "Composite",
    className: "PublicGacha",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      name: {
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      upperTimes: {
        serializedName: "upperTimes",
        type: {
          name: "Number"
        }
      },
      gachaTimes: {
        serializedName: "gachaTimes",
        type: {
          name: "Number"
        }
      },
      iosDownloadUrl: {
        serializedName: "iosDownloadUrl",
        type: {
          name: "String"
        }
      },
      androidDownloadUrl: {
        serializedName: "androidDownloadUrl",
        type: {
          name: "String"
        }
      },
      canRetry: {
        serializedName: "canRetry",
        type: {
          name: "Boolean"
        }
      },
      retryInterval: {
        serializedName: "retryInterval",
        type: {
          name: "Number"
        }
      },
      createdAt: {
        serializedName: "createdAt",
        type: {
          name: "DateTime"
        }
      },
      startTime: {
        serializedName: "startTime",
        type: {
          name: "DateTime"
        }
      },
      endTime: {
        serializedName: "endTime",
        type: {
          name: "DateTime"
        }
      },
      gameTitle: {
        serializedName: "gameTitle",
        type: {
          name: "String"
        }
      },
      developerName: {
        serializedName: "developerName",
        type: {
          name: "String"
        }
      },
      iconImageUrl: {
        serializedName: "iconImageUrl",
        type: {
          name: "String"
        }
      },
      giftDetail: {
        serializedName: "giftDetail",
        type: {
          name: "String"
        }
      },
      gameIntroduction: {
        serializedName: "gameIntroduction",
        type: {
          name: "String"
        }
      },
      articleUrl: {
        serializedName: "articleUrl",
        type: {
          name: "String"
        }
      },
      gameReleaseTime: {
        serializedName: "gameReleaseTime",
        type: {
          name: "String"
        }
      },
      officialSiteUrl: {
        serializedName: "officialSiteUrl",
        type: {
          name: "String"
        }
      },
      gachaCount: {
        serializedName: "gachaCount",
        type: {
          name: "Number"
        }
      },
      isHeld: {
        serializedName: "isHeld",
        type: {
          name: "Boolean"
        }
      }
    }
  }
};

export const ApproveGachaWinningResponse: msRest.CompositeMapper = {
  serializedName: "ApproveGachaWinningResponse",
  type: {
    name: "Composite",
    className: "ApproveGachaWinningResponse",
    modelProperties: {
      failedWinnings: {
        serializedName: "failedWinnings",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "GachaWinning"
            }
          }
        }
      },
      err: {
        serializedName: "err",
        type: {
          name: "String"
        }
      },
      approvedWinnings: {
        serializedName: "approvedWinnings",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "GachaWinning"
            }
          }
        }
      }
    }
  }
};

export const EmailSendRequest: msRest.CompositeMapper = {
  serializedName: "EmailSendRequest",
  type: {
    name: "Composite",
    className: "EmailSendRequest",
    modelProperties: {
      title: {
        required: true,
        serializedName: "title",
        type: {
          name: "String"
        }
      },
      body: {
        required: true,
        serializedName: "body",
        type: {
          name: "String"
        }
      },
      targetOs: {
        required: true,
        serializedName: "targetOs",
        type: {
          name: "String"
        }
      }
    }
  }
};

export const SendEmailToAllRequest: msRest.CompositeMapper = {
  serializedName: "SendEmailToAllRequest",
  type: {
    name: "Composite",
    className: "SendEmailToAllRequest",
    modelProperties: {
      title: {
        required: true,
        serializedName: "title",
        type: {
          name: "String"
        }
      },
      body: {
        required: true,
        serializedName: "body",
        type: {
          name: "String"
        }
      }
    }
  }
};
